import React, { useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import Loader from '../../../assests/animation/Loader2.json';
import OverallReview from '../../../components/OverallReview/OverallReview';
import { InstagramLogo, X_icon } from '../../../Common/SvgIcon/CommonSvgIcons';
import SidePanel from '../../../components/SidePanel/SidePanel';
import GraphHOC from '../../../Common/GraphHOC/GraphHOC';
import TrendsInUserActivity from '../../../Common/TendsInUserActivity/TrendsInUser_activity';

import BarGraph from '../../../Common/BarGraph/BarGraph';
import RatingDonutChart from '../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../Common/FunnelGraph/FunnelGraph';
import VerticalBarGraph from '../../../Common/BarGraph/VarticalBargraph';
import DynamicCorrelationGraph from '../../../components/DynamicCorrelationGraph/DynamicCorrelationGraph';

import { useParsedEndDate, useParsedStartDate } from '../../../utils/ParseDate';
import { useDispatch, useSelector } from 'react-redux';
import { DetailedInsightsData } from '../../../store/redux/slices/topicSlice';
import { convertDateFormat, convertDateFormatString } from '../../../utils/ConvertDateFormat';

const Wrapper = styled.div`
  padding: 30px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const Container = styled.div`
  display: flex;
  gap: 30px;
  height: 380px;
`;

const ChildContainer = styled.div`
  flex: 1;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;

  display: flex;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: center;
  box-sizing: border-box;
`;
const Overview = ({
  overview_tab,
  startDate = '',
  endDate = '',
  filteredStartDate,
  filteredEndDate,
  preview_uuid,
  filterOption,
  filteredData,
  resetFlag,
  view,
  channel,
  job_id,
  hideDropdown,
  formatValue = 'dd/yyyy/MM',
  handleTabClick,
}) => {
  const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];
  const [showSidePanel, setShowSidePanel] = useState(false);
  const genderDemographicsData = [
    {
      name: 'Male',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.male_percentage
          : overview_tab?.gender_demographics?.male_percentage,
      // fill: '#6640B8',
      fill: '#3D9FF8',
    },
    {
      name: 'Female',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.female_percentage
          : overview_tab?.gender_demographics?.female_percentage,
      // fill: '#EAAABD',
      fill: '#FF9AB8',
    },
    {
      name: 'Unknown',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.unknown_percentage
          : overview_tab?.gender_demographics?.unknown_percentage,
      // fill: '#E4E4E4',
      fill: 'rgba(218, 217, 219,  0.8)',
    },
  ];
  const userVerificationData = [
    {
      name: 'Verified',
      value:
        resetFlag === true && filteredData
          ? filteredData?.verified_nonverified?.verified
          : overview_tab?.verified_nonverified?.verified,
      fill: 'rgba(45, 137, 85, 1)',
    },
    {
      name: 'Non Verified',
      value:
        resetFlag === true && filteredData
          ? filteredData?.verified_nonverified?.nonverified
          : overview_tab?.verified_nonverified?.nonverified,
      fill: 'rgba(45, 137, 85, 0.5)',
    },
  ];
  const engagementData = [
    {
      name: 'Likes',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.likes
          : overview_tab?.engagement?.likes,
      // fill: '#353CF780',
      fill: 'rgba(45, 137, 85, 1)',
    },
    {
      name: 'Replies',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.comments
          : overview_tab?.engagement?.comments,
      // fill: '#00D5D0',
      fill: 'rgba(45, 137, 85, 0.8)',
    },
    {
      name: 'Views',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.views
          : overview_tab?.engagement?.views,
      // fill: '#CE66FF',
      fill: ' rgba(45, 137, 85, 0.6)',
    },
    {
      name: 'Reposts',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.reposts
          : overview_tab?.engagement?.reposts,
      // fill: '#A2FF82',
      fill: 'rgba(45, 137, 85, 0.4)',
    },
  ];

  const totalNoOfPosts =
    resetFlag === true && filteredData
      ? filteredData?.total_count
      : overview_tab?.total_count;

  const renderScreen = (
    data,
    showFormatted,
    type,
    sorted,
    isSmall,
    verified,
    showDrillThrough = true
  ) => ({
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          data={data}
          showFormatted={showFormatted}
          type={data[0]?.name === 'Likes' ? null : '%'}
          view={view}
          showDrillThrough={showDrillThrough}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
        />
      ) : (
        <BarGraph
          data={data}
          isSmall={isSmall}
          showFormatted={showFormatted}
          verified={verified}
          sorted={sorted}
          showDrillThrough={showDrillThrough}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          type={data[0]?.name === 'Likes' ? null : '%'}
          /*  borderRadius={'0px 12px 12px 0px'} */
          barHeight={'32px'}
          view={view}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        data={data}
        width={450}
        showDrillThrough={showDrillThrough}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        type={
          data[0]?.name === 'Likes' ? null : type === '%' ? 'percentage' : null
        }
        sorted={sorted}
      />
    ),
    'Donut Chart': (
      <DonutChart
        data={data}
        showDrillThrough={showDrillThrough}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        type={
          data[0]?.name === 'Likes' ? null : type === '%' ? 'percentage' : null
        }
        sorted={sorted}
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        showFormatted={showFormatted}
        showDrillThrough={showDrillThrough}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        data={data}
        type={data[0]?.name === 'Likes' ? '' : '%'}
        sorted={sorted}
      />
    ),
  });


  const [graphData, setGraphData] = useState();
  const startDateParsed = useParsedStartDate(
    resetFlag,
    filteredStartDate,
    startDate,
    formatValue
  );
  const endDateParsed = useParsedEndDate(
    resetFlag,
    filteredEndDate,
    endDate,
    formatValue
  );
  const dispatch = useDispatch();
  const [weekType, setWeekType] = useState(false);
  const [date, setDate] = useState('');
  const [chartType, setChartType] = useState('Volume');

  const [isLoading, setIsLoading] = useState(false);
  const handleDataInsightsFetch = (data) => {
    var inputData = convertDateFormat(data?.date);
    var filter_key = [];
    if (data?.likes_count !== undefined) {
      filter_key?.push('likes');
    }
    if (data?.comments_count !== undefined) {
      filter_key.push('comments');
    }
    if (data?.reposts !== undefined) {
      filter_key.push('reposts');
    }
    if (data?.views !== undefined) {
      filter_key.push('views');
    }
    setDate(convertDateFormatString(inputData?.dateString));
    dispatch(
      DetailedInsightsData({
        preview_uuid: preview_uuid,
        job_id: job_id,
        insight_date: inputData?.dateString,
        insight_type: weekType === true ? 'week' : inputData?.type,
        filter_key: filter_key,
      })
    )
      .then((res) => {
        setGraphData(res?.payload?.response);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };
  return (
    <>
      {resetFlag === true && filteredData === undefined ? (
        <div style={{ marginTop: '-80px' }} data-testid='loader'>
          <Lottie
            data-testid='loader'
            animationData={Loader}
            loop={true}
            width='100px'
            height='100px'
          />
        </div>
      ) : (
        <Wrapper>
          <SidePanel
            isOpen={showSidePanel}
            setIsOpen={(data) => setShowSidePanel(data)}
            pointGraphData={graphData}
            date={date}
            isLoading={graphData === null ? true : false}
            channel={channel}
            startDate={startDateParsed}
            endDate={endDateParsed}
            chartType={chartType}
          />
          <Container>
            <ChildContainer justify='flex-start'>
              <OverallReview
                margin={'15px'}
                backgroundColor='rgba(45, 137, 85, 1)'
                icon={X_icon}
                endDateParsed
                inforText='The total number of posts relevant to your query within the specified time period.'
                message={
                  startDateParsed?.length < 1 ||
                  startDateParsed === undefined ||
                  startDateParsed === null
                    ? `${totalNoOfPosts} Relevant posts were observed for this evaluation`
                    : `${totalNoOfPosts} Relevant posts were observed From ${startDateParsed} to ${endDateParsed}`
                }
                // message= {`${totalNoOfPosts} Relevant posts were observed From ${format(startDateParsed, formatValue)} to ${format(endDateParsed, formatValue)}`}
              />
            </ChildContainer>
           
            <ChildContainer>
              <GraphHOC
                title={'Engagement'}
                options={options}
                renderScreen={renderScreen(
                  engagementData,
                  true,
                  undefined,
                  true,
                  true,
                  undefined,
                  false
                )}
                startDate={startDateParsed}
                endDate={endDateParsed}
                option={filterOption}
                hideDropdown={hideDropdown}
                formatValue={formatValue}
                infoText={
                  'The total number of likes, replies, views, and reposts on posts relevant to your query within the specified time period.'
                }
              />
            </ChildContainer>
            {/* )} */}
          </Container>
          <Container>
            <ChildContainer>
              <GraphHOC
                title={'Gender Demographics'}
                options={options}
                renderScreen={renderScreen(
                  genderDemographicsData,
                  false,
                  '%',
                  undefined,
                  true
                )}
                startDate={startDateParsed}
                endDate={endDateParsed}
                option={filterOption}
                hideDropdown={hideDropdown}
                formatValue={formatValue}
                infoText={
                  'The percentage gender distribution of user accounts relevant to your query, with categories for Male, Female, and Unknown when gender data is unavailable.'
                }
              />
            </ChildContainer>
            <ChildContainer>
              <GraphHOC
                title={'Verified and Non verified Users'}
                options={options}
                renderScreen={renderScreen(
                  userVerificationData,
                  false,
                  '%',
                  true,
                  true,
                  true
                )}
                startDate={startDateParsed}
                endDate={endDateParsed}
                option={filterOption}
                hideDropdown={hideDropdown}
                formatValue={formatValue}
                infoText={
                  'The percentage distribution of verified and unverified users relevant to your query within the specified time period, with verified users confirmed by X as authentic.'
                }
              />
            </ChildContainer>
          </Container>
          {/* <ChildContainer>
            <TrendsInUserActivity
              data1={{
                trends_in_user_activity:
                  resetFlag === true && filteredData
                    ? filteredData?.volume
                    : overview_tab?.volume,
              }}
              ylabel='Volume'
              title='Volume'
              hideDropdown={hideDropdown}
              startDate={startDateParsed}
              endDate={endDateParsed}
              formatValue={formatValue}
              infoText={
                'Track the total number of posts over a specified time period.'
              }
            />
          </ChildContainer> */}
          <ChildContainer>
            <TrendsInUserActivity
              // data1={{
              //   trends_in_user_activity:
              //     resetFlag === true && filteredData
              //       ? filteredData?.trends_in_user_activity
              //       : overview_tab?.trends_in_user_activity,
              // }}
              data1={
                chartType !== 'Engagements'
                  ? {
                      trends_in_user_activity:
                        resetFlag === true && filteredData
                          ? filteredData?.volume
                          : overview_tab?.volume,
                    }
                  : {
                      trends_in_user_activity:
                        resetFlag === true && filteredData
                          ? filteredData?.trends_in_user_activity
                          : overview_tab?.trends_in_user_activity,
                    }
              }
              ylabel={chartType === 'Engagements' ? 'Engagement' : 'Volume'}
              title={
                chartType === 'Engagements'
                  ? 'Trends in User Activity'
                  : 'Volume'
              }
              hideDropdown={false}
              startDate={startDateParsed}
              typeVal='twitter'
              channel={channel}
              setChartType={(data) => setChartType(data)}
              endDate={endDateParsed}
              formatValue={formatValue}
              showFilters={true}
              dataPointClickEnabled={true}
              onEmitTimeSpanClick={setWeekType}
              handleDataPoint={(data) => {
                setIsLoading(true);
                setGraphData(null);
                handleDataInsightsFetch(data?.payload);
                setIsLoading(false);
                setShowSidePanel(true);
              }}
              infoText={
                chartType === 'Engagements'
                  ? 'Track the total engagement on posts, combining likes, comments, reposts, and views, over a specified time period.'
                  : 'Track the total number of posts over a specified time period.'
              }
            />
          </ChildContainer>
          {/* <ChildContainer>
            <TrendsInUserActivity
              data1={{
                trends_in_user_activity:
                  resetFlag === true && filteredData
                    ? filteredData?.impression_trends
                    : overview_tab?.impression_trends,
              }}
              ylabel='Impressions'
              title='Impressions'
              hideDropdown={hideDropdown}
              startDate={startDateParsed}
              endDate={endDateParsed}
              formatValue={formatValue}
              infoText={
                'Tracks total impressions, representing an estimate of how many times posts could have been viewed, calculated as the sum of the follower counts of users whose posts are included in the topic during the specified time period.'
              }
            />
          </ChildContainer> */}
          <DynamicCorrelationGraph
            correlationAnalysisData={overview_tab?.heat_map}
            startDate={startDateParsed}
            endDate={endDateParsed}
          ></DynamicCorrelationGraph>
        </Wrapper>
      )}
    </>
  );
};

export default Overview;
